import { createContext, useContext } from 'react';

const UserContext = createContext({});
const ConfigContext = createContext({});

export function AppContext({ children, userInfo, appConfig }) {
  return (
    <UserContext.Provider value={userInfo}>
      <ConfigContext.Provider value={appConfig}>
        {children}
      </ConfigContext.Provider>
    </UserContext.Provider>
  );
}

export function useUserInfo() { return useContext(UserContext); }
export function useAppConfig() { return useContext(ConfigContext); }
